<template>
    <div class="header_menu" v-if="isShow" @mouseleave="hideMenu">
        <div class="menu_content">
            <div class="menu_option">
                <div class="column">
                    <a class="menu_" v-if="!lotteryList[0].subItem"  v-for="(item,index) in lotteryList" :key="index" :href="item.url" :target="RegExp(/http/).test(item.url) ? '_blank': ''" @click="hideMenu">
                        {{item.name}}
                     </a>
                </div>
                <div class="row" v-for="(item,index) in lotteryList" :key="index" v-if="lotteryList[0].subItem" :class="lotteryList.length >1 && index!=lotteryList.length-1 ? 'addline' : ''">
                    <div class="title">{{item.name}}</div>
                    <div class="menu-item">
                      <div class="item-wrapper" v-for="(subItem,_index) in item.subItem" :key="_index" >
                        <a :href="subItem.url" :target="RegExp(/http/).test(subItem.url) ? '_blank': ''">{{subItem.name}}</a>
                        <img v-if="subItem.newImg" class="icon" src="@/img/new_img.png">
                      </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        name: 'HeaderMenu',
        props: {
            msg: String,
            lotteryList: {
                type: Array,
                default: []
            }
        },
        data() {
        return {
                isShow: true,
            }
        },
        components: {
        },
        methods: {
            showMenu () {
                this.isShow = true;
            },
            hideMenu () {
                this.$emit("hideMenu");
            },
            mouseEventHide () {
                this.$nextTick(() => {
                    this.$emit("hideMenu");
                }); 
            }
        },
        mounted() {      
            document.addEventListener("click", this.mouseEventHide, false);
        },
        destroyed() {
            document.removeEventListener("click", this.mouseEventHide, false);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .header_menu {
        position: absolute;
        z-index: 100;
        height: auto;
        width: auto;
        min-width: 1.5rem;
        border-radius: 6px;
        background-color: rgba(255, 104, 25, 0.9);
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        .menu_content {
            position: relative;
            box-sizing: border-box;
            .menu_option{     
                width: auto;
                height:auto;
                max-height:500px;
                padding: 18px 0;
                .column{
                    display: flex;
                    flex-flow: column;
                    text-align:  center;
                    a{
                        font-size: 16px;
                        color: #ffffff;
                        margin: 7px 0;                                       
                    }
                    a:hover{
                        color: #ffed74;
                        text-decoration: underline;   
                    }
                }
                .row{
                    display: flex;
                    flex-direction: row;
                    padding: 28px 30px 0;
                    justify-content: space-around;
                    .title{
                        font-weight: bold;
                        font-size: 18px;
                        color: #8f3303;
                        text-align: left;
                        width: auto;
                        flex-basis: 120px;
                    }
                    .menu-item{
                      display: flex;
                      flex-wrap: wrap;
                      flex:1;
                      position:relative;
                    }
                    a{
                      font-size: 16px;
                      color: #ffffff;
                      text-align: left;
                      padding: 12px 5px;
                    }
                    a:hover{
                        color: #ffed74;
                         text-decoration: underline;   
                    }
                    .icon{
                        position: absolute;
                        top: -18px;
                        right: -32px;
                    }
                    .btn{
                        font-size: 18px;
                        font-weight: 300;
                        font-stretch: normal;
                        text-align: left;
                        color: #a0abc1;
                        margin-right: 0.4rem;
                    }
                }
              .item-wrapper{position:relative; margin: 8px 5px 24px;}
              .row.addline, .row.addline + .row{padding-top: 20px;}
              .row.addline .item-wrapper, .row.addline + .row .item-wrapper{margin: 0 5px 14px;}

                  .row.addline .menu-item:before{
                        content: "";
                        display: block;
                        width: 100%;
                        left: 2px;
                        bottom: -1px;
                        border-bottom: 1px solid #ff9f6d;
                        position: absolute;
                    }
                .menu_item{ 
                    text-align: center;
                    cursor: pointer;                  
                    span{
                        color: #ffffff;
                        font-size: 15px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 0.4rem;
                        letter-spacing: normal;
                    }
                    span:hover{
                        color: #ffe6cc;
                    }
                }
                .menu_item:hover{ 
                    background-color: rgba(253, 145, 65, 1);
                }
                .nopint{
                    pointer-events: none;
                }
            }
        }
        
    }
</style>